//编码
export const escapeValue = (function(){
    let map = {
        r:/\<|\>|\&|\r|\n|\s|\'|\"/g,
        '<':'&lt;','>':'&gt;','&':'&amp;',' ':'&nbsp;','"':'&quot;',"'":'&#39;','\n':'<br/>','\r':''
    };
    return function(content){
        return content.replace(map.r, function($1){
           let result = map[!map.i ? $1.toLowerCase() : $1];
           return result != null ? result : $1;
        });
    };
})();
//合并
export const mergeList = function(slist, dlist){
    slist = slist || [];
    dlist = dlist || [];
    let maparr = function(item){
        let index = slist.indexOf(item);
        // remove item to list
        if(index >= 0){
            slist.splice(index, 1);
        }
        // add item to list
        slist.unshift(item);
    };
    for(var i=dlist.length-1;i>=0;i--){
        maparr(dlist[i]);
    }
    return slist;
};
//获取样式
export const getStyle = function(ele, attr){
    if(typeof window.getComputedStyle != 'undefined'){ 
        //如果支持W3C，使用getComputedStyle来获取样式 
        return window.getComputedStyle(ele, null)[attr];            
    }
    else if(ele.currentStyle){ 
        return ele.currentStyle[attr];       
    }
}
//获取偏移坐标
export const getOffset = (function(){
    let isRoot = function(ele){
        return ele == document.body || ele == document.documentElement;
    };
    return function(child, parent = null){
        if(!child){
            return null;
        }
        let result = {x : 0, y : 0};
        let isroot;
        let delta;
        while(!!child && child != parent){
            isroot = isRoot(child);
            delta = isroot ? 0 : child.scrollLeft;
            result.x += child.offsetLeft - delta;
            delta = isroot ? 0 : child.scrollTop;
            result.y += child.offsetTop - delta;
            child = child.offsetParent;
        }
        return result;
    };
})();
//判断是否ie及小于9
export const getIEVersion = (function(){
    const USERAGENT = navigator.userAgent;
    const RegIE = /MSIE (\d+\.\d+);/i;
    let verResult = USERAGENT.match(RegIE);
    if(verResult != null){
        let version = verResult[1];
        version = version.split('.');
        return parseInt(version[0], 10);
    }
    return false;
})();
const Util = {
    escapeValue,
    mergeList,
    getStyle,
    getOffset,
    getIEVersion
}
export default Util;


// WEBPACK FOOTER //
// ./client/component/at/util.js